/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolAlarmIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-alarm"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.35 12.45L13.35 9.18Q13.35 8.63 12.96 8.24Q12.57 7.85 12.03 7.85Q11.47 7.85 11.09 8.24Q10.7 8.63 10.7 9.18L10.7 12.95Q10.7 13.22 10.8 13.46Q10.9 13.7 11.1 13.9L13.72 16.52Q14.1 16.9 14.65 16.9Q15.2 16.9 15.57 16.52Q15.95 16.15 15.95 15.6Q15.95 15.05 15.57 14.68ZM12.03 22.73Q12.03 22.73 11.01 22.73Q10 22.73 8.22 21.96Q6.45 21.2 5.11 19.86Q3.77 18.52 3.01 16.75Q2.25 14.97 2.25 12.95Q2.25 10.93 3.01 9.15Q3.77 7.38 5.11 6.04Q6.45 4.7 8.22 3.94Q10 3.17 12.03 3.17Q14.05 3.17 15.82 3.94Q17.6 4.7 18.94 6.04Q20.27 7.38 21.04 9.15Q21.8 10.93 21.8 12.95Q21.8 14.97 21.04 16.75Q20.27 18.52 18.94 19.86Q17.6 21.2 15.82 21.96Q14.05 22.73 12.03 22.73ZM1.43 7.17Q1.05 6.8 1.05 6.25Q1.05 5.7 1.43 5.33L4.38 2.38Q4.75 2 5.3 2Q5.85 2 6.22 2.38Q6.6 2.75 6.6 3.3Q6.6 3.85 6.22 4.22L3.27 7.17Q2.9 7.55 2.35 7.55Q1.8 7.55 1.43 7.17ZM22.63 7.17Q22.25 7.55 21.7 7.55Q21.15 7.55 20.77 7.17L17.82 4.22Q17.45 3.85 17.45 3.3Q17.45 2.75 17.82 2.38Q18.2 2 18.75 2Q19.3 2 19.68 2.38L22.63 5.33Q23 5.7 23 6.25Q23 6.8 22.63 7.17Z" fill={color} />
    </svg>
  );
}
